import React, { useState } from 'react'
import Tooltip from '@src/components/Tooltip/Tooltip'
import {
  ButtonWrapper,
  CollapsedIconWrapper,
  ExpandedMenu,
  LinearGradientBorder,
  LowerContentWrapper,
  MenuItemWrapper,
  Title,
  UpperContentWrapper,
  WagerLeftItem,
  CustomTimerText,
} from './ProgressMenuItem.styled'
import CountdownTimer from '@src/components/Elements/CountdownTimer'
import ProgressBar from './ProgressBar/ProgressBar'
import GradientButton from '@src/components/Elements/GradientButton/GradientButton'
import { useTranslation } from 'react-i18next'

interface Props {
  isCollapsed: boolean
  icon: React.ReactElement
  title: string
  progress: string
  wagerLeft: string
  expiresAt: string | null
  showClaim: boolean
  customTimerText: string | null
  progressBarColor: string | null
  onClickAction: () => void
}

const ProgressMenuItem = ({
  isCollapsed,
  icon,
  title,
  progress,
  wagerLeft,
  expiresAt,
  showClaim,
  customTimerText,
  progressBarColor,
  onClickAction,
}: Props) => {
  const [hovered, setHovered] = useState(false)
  const { t } = useTranslation()

  const showProgressOrClaim = () => {
    if (showClaim) {
      return (
        <ButtonWrapper>
          <GradientButton onClickAction={onClickAction} name={t('menu.progressItem.claimNow', 'Claim Now')} />
        </ButtonWrapper>
      )
    }

    if (hovered) {
      return (
        <WagerLeftItem>
          {t('menu.progressItem.wagerLeft', 'Wager left ${{amount}}', { amount: wagerLeft })}
        </WagerLeftItem>
      )
    }

    return <ProgressBar $progress={progress} $customColor={progressBarColor} />
  }

  const iconWithSize = React.cloneElement(icon, { width: '16', height: '16' })

  return (
    <>
      <MenuItemWrapper onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
        {isCollapsed ? (
          <Tooltip
            type="dark"
            place="right"
            text={t('menu.progressItem.tooltip', '{{title}} {{progress}}%', { title, progress })}
          >
            <LinearGradientBorder onClick={onClickAction}>
              <CollapsedIconWrapper>{iconWithSize}</CollapsedIconWrapper>
            </LinearGradientBorder>
          </Tooltip>
        ) : (
          <ExpandedMenu onClick={onClickAction}>
            <UpperContentWrapper>
              {iconWithSize}
              <Title>{title}</Title>
              {showProgressOrClaim()}
            </UpperContentWrapper>
            {!showClaim && (
              <LowerContentWrapper>
                {customTimerText ? (
                  <CustomTimerText>{customTimerText}</CustomTimerText>
                ) : (
                  <CountdownTimer expiresAt={expiresAt} />
                )}
              </LowerContentWrapper>
            )}
          </ExpandedMenu>
        )}
      </MenuItemWrapper>
    </>
  )
}

export default ProgressMenuItem
